export default "__VITE_ASSET__51a99d14__"